<template>
  <vetster-modal
    ref="citySearch"
    cancel-label=""
    :header="$t('app.find-vet-near-you')"
    @close="close"
    @cancel="close"
  >
    <vetster-search-location-picker
      v-if="geo"
      class="z-999 py-4"
      hide-change
      :geo="geo"
      :countries="country"
      @change="handleChange"
      @location-selected="submitSearch"
    />
  </vetster-modal>
</template>

<script>
import { mapState } from 'vuex';

import VetsterModal from '@/components/VetsterModal';
import VetsterSearchLocationPicker from '@/components/VetsterSearchLocationPicker';
import Designation from '@/enums/Designation';

export default {
  name: 'VetsterCitySearchModal',

  components: {
    VetsterModal,
    VetsterSearchLocationPicker,
  },

  props: {
    open: {
      default: false,
      type: Boolean,
    },
    url: {
      required: true,
      type: String,
    },
    geo: {
      default: null,
      type: Object,
    },
    country: {
      type: [String],
      required: true,
    },
    isGlobalUser: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState('search', ['inputs']),

    searchParams() {
      return new URLSearchParams({
        city: this.inputs.city,
        province: this.inputs.province,
        country: this.inputs.country,
        page: 1,
        designation: Designation.Veterinarian,
      });
    },
  },

  watch: {
    open(open) {
      if (open) {
        this.$refs.citySearch?.open();
      } else {
        this.$refs.citySearch?.close();
      }
    },
  },

  async created() {
    await this.$store.commit('setIsGlobalUser', this.isGlobalUser);
  },

  methods: {
    close() {
      this.$emit('close');
    },
    handleChange() {
      this.$emit('change');
    },
    submitSearch() {
      window.location.href = `${this.url}?${this.searchParams.toString()}`;
    },
  },
};
</script>

<style>
.mapboxgl-ctrl-geocoder .suggestions {
  position: static;
}
</style>
